"use client";
import { ModeToggle } from "../ui/mode-toggle";
import { useTranslation } from "@/lib/i18n";
import {
  Footer,
  FooterColumn,
  FooterBottom,
  FooterContent,
} from "../ui/footer";
import { siteConfig } from "@/config/site";

export default function FooterSection() {
  const { t } = useTranslation("common");
  return (
    <footer className="w-full bg-background px-4">
      <div className="mx-auto max-w-container">
        <Footer className="pt-16 pb-8 border-t">
          <FooterContent className="lg:grid-cols-6 md:grid-cols-4 sm:grid-cols-3 grid-cols-2 gap-8">
            <FooterColumn className="col-span-2 sm:col-span-3 md:col-span-4 lg:col-span-3 flex flex-col gap-6">
              <div className="flex items-center gap-2">
                <span className="text-xl font-bold">AI Compliance</span>
              </div>
              <p className="text-sm text-muted-foreground max-w-sm leading-relaxed">
                {t("footer.description")}
              </p>
            </FooterColumn>
            <FooterColumn>
              <h3 className="text-md font-semibold text-foreground mb-1">{t("footer.platform")}</h3>
              <a href="#features" className="text-sm text-muted-foreground hover:text-primary transition-colors">{t("footer.features")}</a>
              <a href="#solutions" className="text-sm text-muted-foreground hover:text-primary transition-colors">{t("footer.solutions")}</a>
              <a href="/changelog" className="text-sm text-muted-foreground hover:text-primary transition-colors">{t("footer.changelog")}</a>
              <a href={siteConfig.docsUrl} className="text-sm text-muted-foreground hover:text-primary transition-colors">{t("footer.documentation")}</a>
            </FooterColumn>
            <FooterColumn>
              <h3 className="text-md font-semibold text-foreground mb-1">{t("footer.frameworks")}</h3>
              <a href="#frameworks" className="text-sm text-muted-foreground hover:text-primary transition-colors">ISO 27001</a>
              <a href="#frameworks" className="text-sm text-muted-foreground hover:text-primary transition-colors">SOC 2</a>
              <a href="#frameworks" className="text-sm text-muted-foreground hover:text-primary transition-colors">GDPR</a>
              <a href="#frameworks" className="text-sm text-muted-foreground hover:text-primary transition-colors">EU AI Act</a>
            </FooterColumn>
            <FooterColumn>
              <h3 className="text-md font-semibold text-foreground mb-1">{t("footer.company")}</h3>
              <a href="https://www.technozor.com" className="text-sm text-muted-foreground hover:text-primary transition-colors">{t("footer.about")}</a>
              <a href={siteConfig.links.linkedin} className="text-sm text-muted-foreground hover:text-primary transition-colors">{t("footer.linkedin")}</a>
              <a href="/support" className="text-sm text-muted-foreground hover:text-primary transition-colors">{t("footer.contact")}</a>
            </FooterColumn>
          </FooterContent>
          <FooterBottom className="mt-16 border-t pt-8">
            <div className="text-sm text-muted-foreground">© {new Date().getFullYear()} {t("footer.rights_reserved")}</div>
            <div className="flex items-center gap-6 text-sm text-muted-foreground">
              <a href={siteConfig.privacyPolicyUrl} className="hover:text-primary transition-colors">{t("footer.privacy_policy")}</a>
              <a href={siteConfig.termsOfServiceUrl} className="hover:text-primary transition-colors">{t("footer.terms_of_service")}</a>
              <ModeToggle />
            </div>
          </FooterBottom>
        </Footer>
      </div>
    </footer>
  );
}
